module.exports = __webpack_public_path__ + "static/media/cpg_ctv_streamingapp_video.204b069a.png";